
(() => {
document.querySelectorAll('.imp').forEach(root => {
const $$ = s => [...root.querySelectorAll(s)];
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
$$('[data-dup]').forEach(t => { t.innerHTML += t.innerHTML; });
const slides = $$('.slide'), dots = $$('.dot'), lbl = root.querySelector('[data-lbl]');
let cur = 0, timer = null; const DUR = 6500;
function go(i){
slides[cur].classList.remove('on'); cur = (i + slides.length) % slides.length; slides[cur].classList.add('on');
dots.forEach((d,k) => { d.classList.remove('on','seen'); if (k < cur) d.classList.add('seen'); });
void dots[cur].offsetWidth; dots[cur].classList.add('on');
lbl.textContent = String(cur+1).padStart(2,'0') + ' / 03'; restart();
}
function restart(){ clearTimeout(timer); if (!reduce) timer = setTimeout(() => go(cur+1), DUR); }
dots.forEach(d => d.addEventListener('click', () => go(+d.dataset.go)));
const hero = root.querySelector('.hero');
hero.addEventListener('mouseenter', () => clearTimeout(timer)); hero.addEventListener('mouseleave', restart);
let sx = null;
hero.addEventListener('touchstart', e => sx = e.touches[0].clientX, {passive:true});
hero.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
restart();
// efecto de onda al pulsar
root.addEventListener('pointerdown', e => { const b = e.target.closest('.btn'); if (!b) return; const r = b.getBoundingClientRect(), s = Math.max(r.width, r.height);
const rp = document.createElement('span'); rp.className = 'ripple'; rp.style.cssText = `width:${s}px;height:${s}px;left:${e.clientX-r.left-s/2}px;top:${e.clientY-r.top-s/2}px`; b.appendChild(rp); setTimeout(() => rp.remove(), 650); });
// barra de compra en móvil
const sb = root.querySelector('[data-sticky]');
addEventListener('scroll', () => { const r = root.getBoundingClientRect(); sb.classList.toggle('on', scrollY > 700 && r.bottom > innerHeight); }, {passive:true});
// aparición al hacer scroll
if (!reduce && 'IntersectionObserver' in window){
const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting){ en.target.classList.remove('pre'); io.unobserve(en.target); } }), {rootMargin:'0px 0px -8% 0px'});
$$('.rv, .m-card').forEach(el => { if (el.getBoundingClientRect().top > innerHeight){ el.classList.add('rv','pre'); io.observe(el); } });
}
if (!reduce && matchMedia('(hover:hover)').matches){
$$('.m-card').forEach(c => {
c.addEventListener('mousemove', e => { const r = c.getBoundingClientRect(); const x = (e.clientX-r.left)/r.width-.5, y = (e.clientY-r.top)/r.height-.5; c.style.transform = `translateY(-6px) rotateX(${-y*8}deg) rotateY(${x*10}deg)`; });
c.addEventListener('mouseleave', () => c.style.transform = '');
});
}
});
})();